import { TextInput } from "flowbite-react";
import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const Answer = ({ question, responses, responsesText, setValue }) => {
  const handleSelection = (answerId) => {
    const isAlreadySelected = responses?.some((response) =>
      question.answers.map((answer) => answer.id).includes(response)
    );

    const newResponses = isAlreadySelected
      ? responses.filter(
          (response) =>
            !question.answers.map((answer) => answer.id).includes(response)
        )
      : responses;

    setValue("responses", [...newResponses, answerId]);

    if (!responses.includes(answerId)) {
      setValue(
        "responsesText",
        responsesText?.filter((item) => item.id !== answerId)
      );
    }
  };

  const handleCommentChange = (answerId, text) => {
    const existingComment = responsesText?.find((item) => item.id === answerId);

    const updatedResponsesText = existingComment
      ? responsesText?.map((item) =>
          item.id === answerId ? { ...item, comment: text } : item
        )
      : [...responsesText, { id: answerId, comment: text }];

    setValue("responsesText", updatedResponsesText);
  };

  const getClassTypeActive = (type) => {
    switch (type) {
      case 1:
        return {
          active: "border-green-500 bg-green-100 text-green-500 font-semibold",
          disactive: "border-gray-300 bg-white text-green-500 font-semibold",
        };
      case 2:
        return {
          active:
            "border-yellow-500 bg-yellow-100 text-yellow-400 font-semibold",
          disactive: "border-gray-300 bg-white text-yellow-400 font-semibold",
        };
      case 3:
        return {
          active: "border-red-500 bg-red-100 text-red-700 font-semibold",
          disactive: "border-gray-300 bg-white text-red-700 font-semibold",
        };
      default:
        return {
          active: "border-gray-500 bg-gray-100 font-semibold",
          disactive: "border-gray-300 bg-white text-gray-600 font-semibold",
        };
    }
  };

  return (
    <div className="border border-gray-200 rounded-md">
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center bg-gray-200 px-2 py-1 gap-2 rounded-t-md">
          <div className="font-semibold text-lg">
            <div className="text-sm md:text-base">{question?.name}</div>
            <small className="font-normal text-gray-600 mt-1 md:-mt-1 block text-xs md:text-sm">
              {question?.description}
            </small>
          </div>
          {responses?.some((response) =>
            question.answers.map((answer) => answer.id).includes(response)
          ) && (
            <FaCheckCircle
              color="green"
              fontSize={20}
              style={{ minWidth: "20px" }}
            />
          )}
        </div>
        <div
          className="flex flex-col gap-2 overflow-y-auto overflow-x-hidden p-3"
          style={{ maxHeight: "500px" }}
        >
          {question?.answers?.map((answer, index) => (
            <React.Fragment key={index}>
              <label
                className={`cursor-pointer rounded-lg border p-2 transition-all duration-300 text-sm md:text-base
            ${
              responses.includes(answer.id)
                ? getClassTypeActive(answer.typeId).active
                : getClassTypeActive(answer.typeId).disactive
            }`}
                onClick={() => handleSelection(answer.id)}
              >
                <input
                  type="checkbox"
                  name={`answer-${answer.id}`}
                  value={answer.id}
                  checked={responses.includes(answer.id)}
                  onChange={() => handleSelection(answer.id)}
                  className="hidden"
                />
                {answer.name}
              </label>
              {responses.includes(answer.id) && (
                <TextInput
                  placeholder="Observação adicional (Opcional)"
                  name={`answer-text-${answer.id}`}
                  onChange={(e) =>
                    handleCommentChange(answer.id, e.target.value)
                  }
                  value={
                    responsesText?.find((item) => +item.id === answer.id)
                      ?.comment
                  }
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Answer;
